import AuthenticationService from '@/services/authentication';
import statusCodes from '@/constants/statusCodes';
import store from '@/store';

let isRefreshing = false;

export default async function callRefreshIfNeeded(error) {
  if (error.status === statusCodes.UNAUTHORIZED && !isRefreshing) {
    isRefreshing = true;

    return AuthenticationService.refreshSession()
      .catch((exceptionError) => {
        // Só o 403 diz que o refresh token não vale mais. Rede, timeout e 5xx são
        // passageiros: encerrar a sessão aqui revogaria um refresh token ainda
        // válido, e uma queda de segundos derrubaria a sessão de vez. O próximo
        // 401 tenta a renovação de novo.
        if (exceptionError?.response?.status === statusCodes.FORBIDDEN) {
          store.dispatch('setRefreshTokenExpired', true);

          AuthenticationService.redirectToLogin(true);
        }
      })
      .finally(() => {
        isRefreshing = false;
      });
  }

  return Promise.resolve();
}
